import { handleActions } from 'redux-actions';
import { MeasuredCookieStateSlice } from './types';
import { measuredCookieReduxKey, cookieKey } from './constants';
import { initializeMeasuredCookie } from './actions';
import { MeasuredCookie } from './MeasuredCookie';

const actionHandler = handleActions<MeasuredCookieStateSlice, any>(
  {
    [initializeMeasuredCookie.toString()]: (
      state,
      { payload }: ReturnType<typeof initializeMeasuredCookie>
    ) =>
      payload && payload.cookies[cookieKey]
        ? MeasuredCookie.decode(payload.cookies[cookieKey])
        : state,
  },
  {}
);

export default {
  [measuredCookieReduxKey as string]: actionHandler,
};
